/**
 * Frontend Initialization
 *
 * This is the main entry point for frontend block functionality.
 * It registers the enrollment store and initializes all block view components.
 *
 * This script should be enqueued on the frontend only (not in the editor).
 */

// Register stores first
import "./store/enrollment-store";
import "./store/cart-store";
import "./auth/auth-store";

// Import view component initializers
// These will auto-initialize when the script loads
import "../loyalty-heading/view";
import "../loyalty-paragraph/view";
import "../join-program-button/view";
import "../earn-rules-list/view";
import "../spend-rules-list/view";
import "../coupons-list/view";
import "../referral-rewards/view";
import "../tiers-list/view";
import "../product-points/view";

// Mount the singleton auth modal (Erratum G — use createElement, not JSX, to keep the file as .ts)
import { createElement, createRoot } from "@wordpress/element";
import { AuthModal } from "./auth/auth-modal";

const AUTH_MOUNT_ID = "leat-auth-modal-root";

function mountAuthModal(): void {
	if (typeof document === "undefined") return;
	if (document.getElementById(AUTH_MOUNT_ID)) return; // idempotent
	const root = document.createElement("div");
	root.id = AUTH_MOUNT_ID;
	document.body.appendChild(root);
	createRoot(root).render(createElement(AuthModal));
}

if (typeof document !== "undefined") {
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", mountAuthModal);
	} else {
		mountAuthModal();
	}
}

/**
 * Debug logging in development
 */
if (process.env.NODE_ENV === "development") {
	console.log("[Leat] Frontend blocks initialized");
}
